import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { HEALTH_LEVEL_VALUES } from 'views/VvsGotchi/config'

const HealthIconImage = ({ health, size }: { health: number; size?: string }) => {
  return <PixelatedImage src={getHealthIconSrc(health)} width={size ?? '18px'} height={size ?? '18px'} whenRetina />
}

export default HealthIconImage

const getHealthIconSrc = (health: number) => {
  if (health >= HEALTH_LEVEL_VALUES.excellent) return '/images/vvsGotchi/health/excellent.png'
  if (health >= HEALTH_LEVEL_VALUES.healthy) return '/images/vvsGotchi/health/healthy.png'
  if (health >= HEALTH_LEVEL_VALUES.normal) return '/images/vvsGotchi/health/normal.png'
  if (health >= HEALTH_LEVEL_VALUES.unhealthy) return '/images/vvsGotchi/health/unhealthy.png'
  return '/images/vvsGotchi/health/sick.png' // HEALTH_LEVEL_VALUES.sick
}
